// src/handover/handoverQueries.js

export const BaseReservationFields = `
  id
  CompanyId
  carId
  originalCarId
  originalCarName
  originalCarPlate
  carSubstitutions
  status
  title
  start
  end
  pickupAt
  pickupLocation
  dropoffAt
  dropoffLocation
  reservationDate
  reservationRef
  customerName
  customerEmail
  customerPhone
  flightNumber
  phoneNumbers
  babyCarSeat
  depositAmount
  rentalAmount
  depositCurrency
  rentalCurrency
  platform
  senderEmail
  acceptUrl
  declineUrl
  notes
  approvalStatus
  pickupChecklistStatus
  dropoffChecklistStatus
  createdAt
  updatedAt
`;



// NEW: full handover fields so view mode has everything
export const BaseHandoverFields = `
  id
  CompanyId
  reservationId
  type
  status

  filledBySub
  filledByEmail

  customerName
  customerEmail
  customerPhone
  licenseNumber

  carId
  carName
  carPlate

  odometerKm
  fuelLevelPercent
  exteriorCondition
  interiorCondition
  damageNotes
  equipmentNotes

  carPhotoKeys
  damagePhotoKeys
  signatureKey

  ipAddress
  signedAt
  createdAt
  updatedAt
`;

export const SubmitHandoverForm = /* GraphQL */ `
  mutation SubmitHandoverForm($input: SubmitHandoverFormInput!) {
    submitHandoverForm(input: $input)
  }
`;

export const GetReservation = /* GraphQL */ `
  query GetReservation($id: ID!) {
    getReservation(id: $id) {
      ${BaseReservationFields}
    }
  }
`;

export const ListCars = /* GraphQL */ `
  query ListCars {
    listCars(limit: 1000) {
      items { id name plate CompanyId active category }
      nextToken
    }
  }
`;

// IMPORTANT: this is what your HandoverFormPage uses
export const HandoverByReservation = /* GraphQL */ `
  query HandoverByReservation($reservationId: ID!) {
    handoverByReservationByType(
      reservationId: $reservationId
      sortDirection: DESC
      limit: 50
    ) {
      items {
        ${BaseHandoverFields}
      }
      nextToken
    }
  }
`;

export const HandoverContractPdf = /* GraphQL */ `
  query HandoverContractPdf($handoverId: ID!) {
    handoverContractPdf(handoverId: $handoverId)
  }
`;
